import ProductList from "@/modules/erp/pages/product/List";
import ProductEdit from "@/modules/erp/pages/product/Edit";
import CustomerList from "@/modules/erp/pages/customer/List";
import CustomerEdit from "@/modules/erp/pages/customer/Edit";
import OrderList from "@/modules/erp/pages/order/List";
import OrderEdit from "@/modules/erp/pages/order/Edit";
import OrderDetail from "@/modules/erp/pages/order/Detail";
import AfterSaleList from "@/modules/erp/pages/aftersale/List";
import AfterSaleEdit from "@/modules/erp/pages/aftersale/Edit";
import AfterSaleDetail from "@/modules/erp/pages/aftersale/Detail";
import CustomerBill from "@/modules/erp/pages/statement/CustomerBill";
import CustomerBillDetail from "@/modules/erp/pages/statement/CustomerBillDetail";
import BizBillStat from "@/modules/erp/pages/statement/BizBillStat";
import BizBillStatDetail from "@/modules/erp/pages/statement/BizBillStatDetail";

export default [
    {
        path: '/erp/product/list',
        name: 'ProductList',
        component: ProductList,
        meta: {
            caption: '产品管理',
        }
    },
    {
        path: '/erp/product/edit',
        name: 'ProductEdit',
        component: ProductEdit,
        meta: {
            caption: '编辑产品',
        }
    },
    {
        path: '/erp/customer/list',
        name: 'CustomerList',
        component: CustomerList,
        meta: {
            caption: '客户管理',
        }
    },
    {
        path: '/erp/customer/edit',
        name: 'CustomerEdit',
        component: CustomerEdit,
        meta: {
            caption: '编辑客户',
        }
    },
    {
        path: '/erp/order/list',
        name: 'OrderList',
        component: OrderList,
        meta: {
            caption: '订单管理',
        }
    },
    {
        path: '/erp/order/edit',
        name: 'OrderEdit',
        component: OrderEdit,
        meta: {
            caption: '下单',
        }
    },
    {
        path: '/erp/order/detail',
        name: 'OrderDetail',
        component: OrderDetail,
        meta: {
            caption: '订单详情',
        }
    },
    {
        path:'/erp/aftersale/list',
        name: 'AfterSaleList',
        component: AfterSaleList,
        meta: {
            caption: "售后单"
        }
    },
    {
        path:'/erp/aftersale/edit',
        name: 'AfterSaleEdit',
        component: AfterSaleEdit,
        meta: {
            caption: "编辑售后单"
        }
    },
    {
        path:'/erp/aftersale/detail',
        name: 'AfterSaleDetail',
        component: AfterSaleDetail,
        meta: {
            caption: "售后单详情"
        }
    },
    {
        path:'/erp/statement/customerbill',
        name: 'CustomerBill',
        component: CustomerBill,
        meta: {
            caption: "对账单管理"
        }
    },
    {
        path:'/erp/statement/customerbill/detail',
        name: 'CustomerBillDetail',
        component: CustomerBillDetail,
        meta: {
            caption: "对账单详情"
        }
    },
    {
        path:'/erp/statement/bizbill',
        name: 'BizBillStat',
        component: BizBillStat,
        meta: {
            caption: "业务账单统计"
        }
    },
    {
        path:'/erp/statement/bizbill/detail',
        name: 'BizBillStatDetail',
        component: BizBillStatDetail,
        meta: {
            caption: "账单统计详情"
        }
    }
];



// WEBPACK FOOTER //
// ./src/modules/erp/router.js